module.exports = __webpack_public_path__ + "static/img/arthroscopy-08.9154e98.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/arthroscopypic/arthroscopy-08.jpg
// module id = n3d0
// module chunks = 51